import { CustomPDFReportModalEventName } from '../features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { CustomPDFReportType } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-type.enum';
/**
 * Returns the wizard steps for generating the report on the Report Builder page or the Custom PDF Reports List Page.
 * @param report: CustomPDFReport to get wizard steps for.
 */
export const getReportBuilderWizardSteps = (report) => {
    // Remove the report menu step since a report will already be selected
    let steps = report.wizard_steps.filter((step) => step.eventName !== CustomPDFReportModalEventName.SHOW_REPORT_MENU_MODAL);
    // Add the security search step if it is missing, unless the report doesn't actually need one
    if (report.report_type === CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW &&
        report.num_required_securities !== 0 &&
        !report.wizard_steps.some((step) => step.eventName === CustomPDFReportModalEventName.SHOW_SECURITY_SEARCH_MODAL)) {
        steps = [{ eventName: CustomPDFReportModalEventName.SHOW_SECURITY_SEARCH_MODAL }, ...steps];
    }
    return steps;
};
export function isLegacyYRatingReport(report) {
    return report.report_type === 'legacy_y_rating';
}
